import { ExitPendingRenewalStatusRequest } from '@cbinsights/userv2service/userv2service';
import { request } from 'client/modules/common/utils/request';

export const exitPendingRenewalStatus = (
  req: Partial<ExitPendingRenewalStatusRequest>
): Promise<void> =>
  request({
    url: '/service/userv2service/ExitPendingRenewalStatus',
    body: req,
  }).then((r) => r.body);
